import { useMemo, useState } from 'react'

import { EllipsisOutlined } from '@ant-design/icons'
import { Divider, Flex, Popover, PopoverProps, Space } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { MenuButton } from '../../ui/MenuButton'
import { useToolbarStore } from '../Store/hooks/useStore'

const align: PopoverProps['align'] = {
  offset: [0, 10]
}

export const ToolbarMoreButton = () => {
  const { moreGroups } = useToolbarStore(state => pick(state, ['moreGroups']))

  const moreNodes = useMemo(() => {
    return moreGroups
      .map((group, groupIndex) => {
        const filteredGroup = group.filter(Boolean)
        return (
          !!filteredGroup.length && (
            <Flex key={groupIndex} gap={8}>
              {group}
            </Flex>
          )
        )
      })
      .filter(Boolean)
  }, [moreGroups])

  const [open, setOpen] = useState(false)

  return (
    <Popover
      align={align}
      arrow={false}
      open={open}
      placement='bottomRight'
      trigger='click'
      content={
        <Space separator={<Divider orientation='vertical' />}>
          {moreNodes}
        </Space>
      }
    >
      <MenuButton
        tooltip='更多'
        icon={
          <EllipsisOutlined
            style={{
              fontSize: 24
            }}
          />
        }
        onClick={() => setOpen(!open)}
      />
    </Popover>
  )
}
